const localeKey = 'locale';

/* Site wide cookie - drop consent
      Input: consent.local.xxxxx.io
      Output: local.xxxxx.io
*/
const domain = window.location.hostname
    .replace('www.', '')
    .split('.')
    .splice(1)
    .join('.');

/*
Gets language from browser in this hierarchy:
   - User settings
   - Browser language (where it was installed)
   - System language
 */
export const getBrowserLocale = () => {
    if (navigator.languages && navigator.languages.length) {
        return navigator.languages;
    } else {
        return (
            navigator.userLanguage ||
            navigator.language ||
            navigator.browserLanguage
        );
    }
};

export const getLocaleCookie = () => {
    if (!document.cookie) {
        return false; // probably should return an error so we can track it
    }
    let splitCookie = document.cookie.split(';');

    let locale = splitCookie.find((item) => {
        return item.trim().startsWith(localeKey);
    });

    if (locale) {
        // Return the value of the cookie
        return locale.split(`${localeKey}=`)[1];
    }

    return false;
};

// site-wide cookie
export const setLocaleCookie = (locale) => {
    let localeCookie = `${localeKey}=${locale}; path=/; domain=${domain};`;
    document.cookie = localeCookie;
    return;
};



// WEBPACK FOOTER //
// ./shared/lib/language/language.js